"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Button = _interopRequireDefault(require("../Components/Button.js"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Snackbar service
 *
 * Imperative API wrapper for Notistack.
 *
 * Requires a `SnackbarProvider` to be rendered while used.
 */
class SnackbarService {
  /**
   * Notistack reference
   *
   * (Set by `SnackbarProvider`)
   * 
   * @type {Object|null}
   */
  static notistack = null;
  /**
   * Close a snackbar by its key.
   *
   * @param {mixed} key
   * @return {void}
   */

  static close(key) {
    SnackbarService.notistack?.closeSnackbar?.(key);
  }
  /**
   * Display a snackbar.
   *
   * When `variant` is `undefined`, an appropriate default variant 
   * is assigned to match the type of `msg`. Note that `options.variant` 
   * will always override `variant` and its default assignation when set.
   * 
   * @param {String} msg Automatically stringified when not already one
   * @param {String} variant optional Notistack variant
   * @param {Object} options optional Notistack `enqueueSnackbar()` options
   * @return {void}
   */


  static snack(msg) {
    let variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (variant === undefined) {
      variant = msg instanceof Error ? "error" : "default";
    }

    if (options.withCloseButton) {
      options.action = key => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: "inherit",
        label: "OK",
        onClick: SnackbarService.close,
        size: "small",
        variant: "text",
        value: key
      });

      delete options.withCloseButton;
    }

    SnackbarService.notistack?.enqueueSnackbar?.(`${msg}`, {
      variant,
      ...options
    });
  }

}

var _default = SnackbarService;
exports.default = _default;